import OrderingTaskList from './ordering-tasks-list'

export default OrderingTaskList
